import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RunAISummarizeQueryResultsVariables = Types.Exact<{
  input: Types.AISummarizeQueryResultsInput;
}>;

export type RunAISummarizeQueryResults = {
  aiSummarizeQueryResults: Pick<
    Types.AIInferenceStream,
    'streamName' | 'streamId' | 'pinned' | 'private' | 'saved' | 'createdAt' | 'parentStreamId'
  > & { createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser> };
};

export const RunAISummarizeQueryResultsDocument = gql`
  mutation RunAISummarizeQueryResults($input: AISummarizeQueryResultsInput!) {
    aiSummarizeQueryResults(input: $input) {
      streamName
      streamId
      pinned
      private
      saved
      createdBy {
        ...ActorTeaser
      }
      createdAt
      parentStreamId
    }
  }
  ${ActorTeaser}
`;
export type RunAISummarizeQueryResultsMutationFn = Apollo.MutationFunction<
  RunAISummarizeQueryResults,
  RunAISummarizeQueryResultsVariables
>;

/**
 * __useRunAISummarizeQueryResults__
 *
 * To run a mutation, you first call `useRunAISummarizeQueryResults` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAISummarizeQueryResults` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAiSummarizeQueryResults, { data, loading, error }] = useRunAISummarizeQueryResults({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunAISummarizeQueryResults(
  baseOptions?: Apollo.MutationHookOptions<
    RunAISummarizeQueryResults,
    RunAISummarizeQueryResultsVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RunAISummarizeQueryResults, RunAISummarizeQueryResultsVariables>(
    RunAISummarizeQueryResultsDocument,
    options,
  );
}
export type RunAISummarizeQueryResultsHookResult = ReturnType<typeof useRunAISummarizeQueryResults>;
export type RunAISummarizeQueryResultsMutationResult =
  Apollo.MutationResult<RunAISummarizeQueryResults>;
export type RunAISummarizeQueryResultsMutationOptions = Apollo.BaseMutationOptions<
  RunAISummarizeQueryResults,
  RunAISummarizeQueryResultsVariables
>;
export function mockRunAISummarizeQueryResults({
  data,
  variables,
  errors,
}: {
  data: RunAISummarizeQueryResults;
  variables?: RunAISummarizeQueryResultsVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: RunAISummarizeQueryResultsDocument, variables },
    result: { data, errors },
  };
}
